// localStorage-backed persistence for the device token + last-display-name.
// The token is also held as an httpOnly cookie by the server; localStorage
// is the cross-tab + non-cookie fallback (matches the M1 decision).

const TOKEN_KEY = 'schemer.deviceToken';
const NAME_KEY = 'schemer.displayName';

export const tokenStore = {
  get(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set(token: string): void {
    try {
      localStorage.setItem(TOKEN_KEY, token);
    } catch {
      /* private mode or quota */
    }
  },
};

export const nameStore = {
  get(): string | null {
    try {
      return localStorage.getItem(NAME_KEY);
    } catch {
      return null;
    }
  },
  set(name: string): void {
    try {
      localStorage.setItem(NAME_KEY, name);
    } catch {
      /* noop */
    }
  },
};
